import React, { useContext } from 'react';
import { EppoClientContext, fallbackEppoClient, IEppoClient } from '../../eppo/eppoClientContext';

export interface IEppoClientContext {
  eppoClient?: IEppoClient;
}

export function withEppoClientContext<TProps extends {}>(
  Component: React.ComponentType<TProps & IEppoClientContext>,
) {
  function Connected(props: TProps) {
    const eppoClient = useContext(EppoClientContext);
    return <Component eppoClient={eppoClient} {...props} />;
  }

  Connected.displayName = `withEppoClientContext(${Component.displayName || Component.name})`;

  return Connected;
}

export default function EppoClientContextProvider({ eppoClient, children }: IEppoClientContext & { children?: React.ReactNode }) {
  return (
    <EppoClientContext.Provider value={eppoClient ?? fallbackEppoClient}>
      {children}
    </EppoClientContext.Provider>
  );
}
